import {
  Module, ActionTree, MutationTree, GetterTree
} from 'vuex';
import { readCookie, writeCookie } from '@/tools/tools';
import { messageSimple, queryFirstBuy } from '@/services/http';
import { notifysState } from './types';
import { RootState } from '../types';
/**
 * getters
 */
// export const getters: GetterTree<notifysState, RootState> = {
//   addresslist: (state: notifysState) => state.notifysList,
// };

/**
 * mutations
 */
export const mutations: MutationTree<notifysState> = {
  // 收货列表
  USERINFORLIST(state: notifysState, payload: []) {
    state.notifysList = payload;
    writeCookie('notifysList', state.notifysList);
  },
  // 收货列表
  QUERYFIRSTBUY(state: notifysState, payload: []) {
    state.serviceList = payload;
  }
};

/**
 * actions
 */
export const actions: ActionTree<notifysState, RootState> = {
  async messageSimple({ commit }) {
    const res: any = await messageSimple({
      companyId: 1
    });
    commit('USERINFORLIST', res.data.data);
  },
  async queryFirstBuy({ commit }) {
    const res: any = await queryFirstBuy({
      companyId: 1
    });
    commit('QUERYFIRSTBUY', res.data.data);
  }
};
/**
 * state
 */
export const state: notifysState = {
  notifysList: readCookie('notifysList') ? readCookie('notifysList') : {},
  serviceList: {}
};
const namespaced: boolean = true;

export const notifys: Module<notifysState, RootState> = {
  namespaced,
  state,
  mutations,
  actions
};
